var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","d":"M15.78 12.72c.14-.14.22-.331.22-.53v-.38c-.002-.198-.081-.388-.22-.53l-5.14-5.13c-.094-.095-.222-.148-.355-.148-.133 0-.261.053-.355.148l-.71.71c-.094.092-.147.218-.147.35 0 .132.053.258.147.35L13.67 12l-4.45 4.44c-.095.094-.148.222-.148.355 0 .133.053.261.148.355l.71.7c.094.095.222.148.355.148.133 0 .261-.053.355-.148l5.14-5.13z"}));
}

ArrowRight.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
